export enum ROLES {
    User = 'user',
    Admin = 'admin',
    Support='support',
    Manager='manager',
    BDI='bdi',
    exam_admin="exam_admin"
}